<template>
  <div class="row">
    <div class="col-12 mb-4">
      <h4><i class="bx bx-file-blank"></i> General Information</h4>
      <hr />
    </div>
    <div class="col-12">
      <b-alert show dismissible variant="danger" size="sm" v-if="invalid">
        <i class="mdi mdi-block-helper mr-2"></i>{{ errorMessage }}
      </b-alert>
    </div>
    <div class="col-12">
      <div class="form-group row mb-3">
        <label class="col-md-3 col-form-label" for="title">
          {{ $t("malware.title") }}</label
        >
        <div class="col-md-9">
          <input
            id="title"
            type="text"
            class="form-control"
            name="userName"
            v-model="form.title"
            :class="{
              'is-invalid': submitted && $v.form.title.$error,
            }"
          />
          <div
            v-if="submitted && $v.form.title.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.title.required">{{
              $t("form.error.text")
            }}</span>
          </div>
        </div>
      </div>

      <div class="form-group row mb-3">
        <label class="col-md-3 col-form-label" for="desc">
          {{ $t("malware.description") }} Report <br />
          <small>(Short description about report)</small>
        </label>
        <div class="col-md-9">
          <textarea
            name="description"
            id="desc"
            class="form-control"
            cols="30"
            rows="10"
            v-model="form.description"
            :class="{
              'is-invalid': submitted && $v.form.description.$error,
            }"
          ></textarea>
          <div
            v-if="submitted && $v.form.description.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.description.required">{{
              $t("form.error.text")
            }}</span>
          </div>
        </div>
      </div>

      <div class="form-group row mb-3">
        <label class="col-md-3 col-form-label" for="desc"> Malware Icon</label>
        <div class="col-md-9">
          <div
            class="d-inline-block border rounded w-100 text-center"
            :style="
              theme == 'dark'
                ? 'border-color: #32394e !important'
                : 'border-color: #ced4da !important'
            "
          >
            <img
              :src="require('@/assets/images/malware-icon/' + iconName)"
              alt
              class="img-fluid p-4 mt-4"
              width="200px"
            />
          </div>
          <br />
          <b-dropdown
            id="dropdown-form"
            text="Change Icon"
            ref="dropdown"
            class="mt-2"
            variant="primary"
          >
            <b-dropdown-form style="width: 30vw">
              <div class="row">
                <div class="col-4">
                  <div
                    @click="changeMalwareIcon(1)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 1 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/cyber-attack.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
                <div class="col-4">
                  <div
                    @click="changeMalwareIcon(2)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 2 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/adware.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
                <div class="col-4">
                  <div
                    @click="changeMalwareIcon(3)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 3 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/backdoor.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
                <div class="col-4">
                  <div
                    @click="changeMalwareIcon(4)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 4 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/botnet.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
                <div class="col-4 mb-3">
                  <div
                    @click="changeMalwareIcon(5)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 5 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/keylogger.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
                <div class="col-4 mb-3">
                  <div
                    @click="changeMalwareIcon(6)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 6 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/malware.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
                <div class="col-4 mb-3">
                  <div
                    @click="changeMalwareIcon(7)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 7 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/ransomware.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
                <div class="col-4 mb-3">
                  <div
                    @click="changeMalwareIcon(8)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 8 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/spyware.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
                <div class="col-4 mb-3">
                  <div
                    @click="changeMalwareIcon(9)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 9 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/trojan-horse.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
                <div class="col-4 mb-3">
                  <div
                    @click="changeMalwareIcon(10)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 10 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/worm.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
                <div class="col-4 mb-3">
                  <div
                    @click="changeMalwareIcon(11)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 11 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/virus.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
                <div class="col-4 mb-3">
                  <div
                    @click="changeMalwareIcon(12)"
                    class="btn btn-block p-0 m-0 mb-3"
                    :class="[
                      theme == 'dark'
                        ? 'btn-outline-secondary'
                        : 'btn-outline-light',
                      iconId == 12 ? 'btn-active' : '',
                    ]"
                  >
                    <img
                      src="@/assets/images/malware-icon/bomb.png"
                      alt
                      class="img-fluid m-3"
                      width="100px"
                    />
                  </div>
                </div>
              </div>
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-md-3 col-form-label" for="desc">
          {{ $t("malware.report-type") }}</label
        >
        <div class="col-md-9">
          <select
            class="form-control"
            v-model="form.report_type"
            @change="changeReportType"
            :class="{
              'is-invalid': submitted && $v.form.report_type.$error,
            }"
          >
            <option value="">{{ $t("malware.select") }}</option>
            <option value="auto">Automatic</option>
            <option value="manual">Manual Upload</option>
          </select>
          <div
            v-if="submitted && $v.form.report_type.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.report_type.required">{{
              $t("form.error.text")
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-group row mb-3" v-if="form.report_type == 'manual'">
        <label class="col-md-3 col-form-label" for="desc">
          {{ $t("malware.report-file") }} (PDF) <br />
          <small><i>Max.50Mb</i></small>
        </label>
        <div class="col-md-9">
          <div class="custom-file">
            <b-form-file
              :state="fileValid"
              :placeholder="$t('malware.select-file')"
              :class="
                fileValid && submitted && form.report_file == ''
                  ? ''
                  : 'is-invalid'
              "
              @change="upReportFile"
              accept="application/pdf"
            ></b-form-file>
            <div v-if="!fileValid" class="invalid-feedback">
              <span v-if="submitted && form.report_file == ''">{{
                $t("form.error.text")
              }}</span>
              <span v-else>{{ $t("wizard.form.validation.max_size") }}</span>
            </div>
          </div>
          <div
            v-if="submitted && $v.form.report_type.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.report_type.required">{{
              $t("form.error.text")
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { TabContent } from "vue-form-wizard";
import ReportService from "@/helpers/report.service";
import moment from "moment";
import { userService } from "@/helpers/authservice/user.service";

/**
 * Projects-grid component
 */
export default {
  components: { TabContent },
  props: {
    validations: Boolean,
    idReport: { type: String, default: "" },
  },
  data() {
    return {
      submitted: false,
      form: {
        title: "",
        description: "",
        report_type: "",
        report_file: "",
        report_update_file: true,
      },
      theme: localStorage.getItem("theme") ?? "light",
      fileValid: true,
      invalid: false,
      errorMessage: "Something went wrong!",
      iconName: "cyber-attack.png",
      iconId: 1,
    };
  },
  validations: {
    form: {
      title: { required },
      description: { required },
      report_type: { required },
    },
  },
  watch: {
    validations: {
      immediate: true,
      handler(n) {
        if (n) {
          this.validation();
        }
      },
    },
  },
  methods: {
    detailReport() {
      if (this.idReport) {
        let ferr = 0;
        ReportService.detail(this.idReport)
          .then((res) => {
            if (res.status == 201) {
              let new_token = res.data.refresh_access_token;
              userService.splitToken(new_token);
              this.detailReport();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              if (res.data.data.report_type == "auto") {
                this.form = {
                  title: res.data.data.title,
                  description: res.data.data.description,
                  report_type: res.data.data.report_type,
                };
              } else {
                this.form = {
                  title: res.data.data.title,
                  description: res.data.data.description,
                  report_type: res.data.data.report_type,
                  report_file: res.data.data.report_file,
                };
              }
              this.form.report_update_file = false;
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.detailReport();
            } else {
              this.$emit("validation-failed");
              this.invalid = true;
              // this.errorMessage = err;
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log("err ->> ", err);
              }
            }
          });
      }
    },

    saveReport() {
      let ferr = 0;
      let dataReport = null;
      if (this.form.report_type == "manual") {
        dataReport = new FormData();
        dataReport.append("title", this.form.title);
        dataReport.append("description", this.form.description);
        dataReport.append("malware_logo", this.iconName);
        dataReport.append("report_type", this.form.report_type);
        dataReport.append("report_file", this.form.report_file);
      }
      if (this.form.report_type == "auto") {
        dataReport = {
          title: this.form.title,
          description: this.form.description,
          malware_logo: this.iconName,
          report_type: this.form.report_type,
        };
      }
      ReportService.create(dataReport)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.saveReport();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.$emit("id-report", response.data.data.id_report);
            this.$emit("next-tab");
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.saveReport();
          } else {
            this.$emit("validation-failed");
            this.invalid = true;
            // this.errorMessage = err;
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err ->> ", err);
            }
          }
        });
    },
    updateReport() {
      let ferr = 0;
      let dataReport = null;
      if (this.form.report_type == "manual") {
        dataReport = new FormData();
        dataReport.append("title", this.form.title);
        dataReport.append("description", this.form.description);
        dataReport.append("malware_logo", this.iconName);
        dataReport.append("report_type", this.form.report_type);
        dataReport.append("report_file", this.form.report_file);
        dataReport.append("report_update_file", this.form.report_update_file);
      }
      if (this.form.report_type == "auto") {
        dataReport = {
          title: this.form.title,
          description: this.form.description,
          malware_logo: this.iconName,
          report_type: this.form.report_type,
        };
      }
      ReportService.update(this.idReport, dataReport)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.updateReport();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.form.report_update_file = true;
            this.id_report = response.data.data.id_report;
            this.$emit("id-report", response.data.data.id_report);
            this.$emit("next-tab");
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.updateReport();
          } else {
            this.$emit("validation-failed");
            this.invalid = true;
            // this.errorMessage = err;
            if (err.response.status == 401) {
              userService.logout();
            } else {
              this.loading = false;
              console.log("err ->> ", err);
            }
          }
        });
    },
    validation() {
      this.submitted = true;
      this.fileValid = true;
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        if (this.form.report_type != "auto" && this.form.report_file == "") {
          this.fileValid = false;
          this.$emit("validation-failed");
          // console.log("file valid", this.fileValid);
        } else {
          if (this.idReport == "") {
            this.saveReport();
          } else {
            this.updateReport();
          }
        }
      } else {
        this.fileValid = false;
        this.$emit("validation-failed");
      }
      this.$emit("report-type", this.form.report_type);
    },
    changeReportType() {
      this.$emit("report-type", this.form.report_type);
      this.fileValid = true;
      this.form.report_file = "";
    },
    changeMalwareIcon(id) {
      let img = "cyber-attack.png";
      switch (id) {
        case 1:
          img = "cyber-attack.png";
          break;
        case 2:
          img = "adware.png";
          break;
        case 3:
          img = "backdoor.png";
          break;
        case 4:
          img = "botnet.png";
          break;
        case 5:
          img = "keylogger.png";
          break;
        case 6:
          img = "malware.png";
          break;
        case 7:
          img = "ransomware.png";
          break;
        case 8:
          img = "spyware.png";
          break;
        case 9:
          img = "trojan-horse.png";
          break;
        case 10:
          img = "worm.png";
          break;
        case 11:
          img = "virus.png";
          break;
        case 12:
          img = "bomb.png";
          break;
        default:
          break;
      }

      this.iconName = img;
      this.iconId = id;
    },
    upReportFile(evt) {
      const fileSize =
        evt.type == "change"
          ? evt.target.files[0].size
          : evt.dataTransfer.files[0].size;
      const fileType =
        evt.type == "change"
          ? evt.target.files[0].type
          : evt.dataTransfer.files[0].type;
      if (fileSize > 52428800 || fileType != "application/pdf") {
        this.fileValid = false;
      } else {
        this.fileValid = true;
        this.form.report_update_file = true;
        this.form.report_file =
          evt.type == "change"
            ? evt.target.files[0]
            : evt.dataTransfer.files[0];
      }
    },
  },
  mounted() {
    this.detailReport();
  },
};
</script>
<style>
.btn-active {
  background-color: #024284;
}
.btn-active:hover {
  background-color: #024284;
}
</style>